export default function getUrlSearchParams():URLSearchParams {
    const urlString = String(window.location.href).split('?')
    const urlSearch = new URLSearchParams(urlString[1])
    return urlSearch
}